var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 3.95884L8.04041 0.292168C7.64988 -0.0983659 7.01668 -0.0983659 6.62614 0.292168C6.23561 0.682702 6.23561 1.3159 6.62614 1.70644L8.58574 3.66591H1C0.447734 3.66591 0 4.11364 0 4.66591C0 5.21817 0.447734 5.66591 1 5.66591H8.58574L6.62628 7.62564C6.23574 8.01618 6.23574 8.64938 6.62628 9.03991C7.01681 9.43045 7.65001 9.43045 8.04054 9.03991L11.7072 5.37324C12.0976 4.98257 12.0976 4.34937 11.7071 3.95884Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5a33f1f1a928990de2173d3be2dec157.svg";
export { ForwardRef as ReactComponent };